import { Box, DialogContent, DialogTitle, Menu, Typography } from '@mui/material';
import { FC, SyntheticEvent, useState, useRef } from 'react';

export type TInfoDialProps = {
	text: string;
};

export const InfoDial: FC<TInfoDialProps> = ({ text }) => {
	const anchorEl = useRef<HTMLDivElement>(null);
	const [open, setOpen] = useState(false);

	const speedDialTooltipOpen = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(true);
	};
	const speedDialTooltipClose = (e: SyntheticEvent) => {
		e.stopPropagation();
		setOpen(false);
	};

	return (
		<>
			{/* добавить стрелку */}

			<div
				ref={anchorEl}
				onClick={speedDialTooltipOpen}
				style={{ position: 'absolute', right: '0', top: '0', width: '100%', height: '100%' }}
				className="action-speed-dial"
			/>
			<Menu
				anchorEl={anchorEl.current}
				open={open}
				onClose={speedDialTooltipClose}
				sx={{
					'& .MuiPaper-root': {
						width: '300px',
						maxWidth: 'none',
						borderRadius: '12px',
						p: 0,
						m: 0,
					},
					'& .MuiList-root': {
						padding: 0,
						m: 0,
						position: 'relative',
					},
					'& .MuiList-root:before': {
						// borderLeft: '20px solid transparent',
						// borderRight: '20px solid transparent',
						// borderTop: '20px solid #fff',
						position: 'absolute',
						top: '-40px',
						left: '50%',
						height: '10px',
						width: '10px',
						background: 'red',
						transform: 'translateX(-50%)',
					},
				}}
				anchorOrigin={{
					vertical: 'bottom',
					horizontal: 'left',
				}}
				transformOrigin={{
					vertical: 'top',
					horizontal: 'left',
				}}
			>
				<DialogContent sx={{ p: '10px' }}>
					<Box sx={{ display: 'flex' }}>
						<Typography
							sx={{
								fontSize: '3rem',
								color: '#016193',
								fontFamily: 'monospace',
								mr: 1,
								mt: -1,
								fontWeight: 'bold',
								textTransform: 'lowercase',
							}}
						>
							i
						</Typography>
						<Typography sx={{ fontSize: '.8rem', fontStyle: 'italic', color: '#555' }}>
							{text}
						</Typography>
					</Box>
				</DialogContent>
			</Menu>
		</>
	);
};
